/** Situação do clichê no item do pedido para indicar se o mesmo não possui alteração, possui alteração ou é um novo clichê */
export enum EnumSituacaoCliche {
    /** Situação padrão, sem alteração no clichê */
    SEM_ALTERACAO = 1,
    /** Situação em que o clichê possui alguma alteração */
    COM_ALTERACAO = 2,
    /** Situação em que o clichê é novo */
    NOVO = 3
}

/** Interface para definição das situações do clichê */
export interface ISituacaoCliche {
    id: EnumSituacaoCliche;
    label: string;
    legend: string;

    // Flags validadoras
    isSemAlteracao?: boolean;
    isComAlteracao?: boolean;
    isNovo?: boolean;
}

/** Situações do Clichê */
export const SITUACOES_CLICHE: Map<EnumSituacaoCliche, ISituacaoCliche> = new Map([
  [
    EnumSituacaoCliche.SEM_ALTERACAO,
    {
      id: EnumSituacaoCliche.SEM_ALTERACAO,
      label: 'Sem Alteração',
      legend: 'O clichê permanece o mesmo, sem alterações.',
      isSemAlteracao: true
    }
  ],
  [
    EnumSituacaoCliche.COM_ALTERACAO,
    {
      id: EnumSituacaoCliche.COM_ALTERACAO,
      label: 'Com Alteração',
      legend: 'O clichê possui alguma alteração em relação ao atual.',
      isComAlteracao: true
    }
  ],
  [
    EnumSituacaoCliche.NOVO,
    {
      id: EnumSituacaoCliche.NOVO,
      label: 'Novo',
      legend: 'O clichê é completamente novo em relação ao atual.',
      isNovo: true
    }
  ]
]);
